import React, { Component } from 'react';
import { connect } from 'react-redux';
import Task from 'components/admin/work-orders/creation/Task';
import { Modal } from 'react-bootstrap';
import './NewTaskModal.css';
import {
  getForm,
  getShowModal,
} from 'selectors/admin/work-orders/details/new-task';
import {
  attributeChange,
  removeImage,
  setShowModal,
} from 'actions/admin/work-orders/details/new-task';
import {
  getCurrentWorkOrder,
  getSubTradesByTradeId,
  getTrades,
} from 'selectors/admin/work-orders/work-orders';
import {
  loadTradesRequest,
  saveTaskRequest,
} from 'actions/admin/work-orders/creation/tasks';
import { loadSubTradesRequest } from 'actions/admin/work-orders/work-orders';
import { WorkOrderStatusEnum } from 'services/utils/work-order-status-enum';

class NewTaskModal extends Component {
  componentDidMount() {
    if (this.props.trades.length === 0) {
      this.props.dispatch(loadTradesRequest());
    }
  }

  handleCancel = () => {
    this.props.dispatch(setShowModal(false));
  };

  handleChange = (taskId, attribute, value, label) => {
    this.props.dispatch(attributeChange(attribute, value, label));
    if (attribute === 'trade') {
      this.props.dispatch(loadSubTradesRequest(value));
    }
  };

  handleImageRemove = (index) => {
    this.props.dispatch(removeImage(index));
  };

  handleSubmit = () => {
    this.props
      .dispatch(
        saveTaskRequest(
          this.props.form,
          this.props.currentWorkOrder.id,
          this.isPreTask()
        )
      )
      .then((response) => {
        if (response.ok) {
          this.props.dispatch(setShowModal(false));
        }
      });
  };

  isPreTask = () => {
    const statusEnum = WorkOrderStatusEnum.create(
      this.props.currentWorkOrder.status
    );
    return WorkOrderStatusEnum.IN_PROGRESS.equals(statusEnum);
  };

  render() {
    const minMaxImages = {
      min: 3,
      max: 6,
    };
    return (
      <Modal className="new-task-modal" show={this.props.showModal}>
        <Modal.Body>
          <Task
            key={0}
            minMaxImages={minMaxImages}
            task={this.props.form}
            trades={this.props.trades}
            subTradesByTradeId={this.props.subTradesByTradeId}
            onCancel={this.handleCancel}
            onChange={this.handleChange}
            onImageRemove={this.handleImageRemove}
            onSubmit={this.handleSubmit}
            isPreTask={this.isPreTask()}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

export default connect((state) => {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    form: getForm(state),
    showModal: getShowModal(state),
    subTradesByTradeId: getSubTradesByTradeId(state),
    trades: getTrades(state),
  };
})(NewTaskModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/tasks/NewTaskModal.js